export const grievanceApplicantFieldsTelugu = [
  {
    fieldName: 'applicantName',
    fieldTitle: 'దరఖాస్తుదారు పేరు*',
    // validationObj: {
    //   required: 'Please Enter Applicant Name',
    // },
    fieldType: 'text',
  },
  {
    fieldName: 'applicantMobile',
    fieldTitle: 'దరఖాస్తుదారు ఫోన్ నంబర్*',
    // validationObj: {
    //   required: 'Please Enter Applicant Mobile Phone',
    // },
    fieldType: 'text', // Consider adding input masking for phone number format
  },
  {
    fieldName: 'pincode',
    fieldTitle: 'పిన్ కోడ్',
    // validationObj: {
    //   required: 'Please Enter Pincode',
    // },
    fieldType: 'number',
  },
  {
    fieldName: 'state',
    fieldTitle: 'రాష్ట్రం*',
    // validationObj: {
    //   required: 'Please Select State',
    // },
    fieldType: 'select',
    options: [], // You'll need to populate this with state options
  },
  {
    fieldName: 'district',
    fieldTitle: 'జిల్లా*',
    // validationObj: {
    //   required: 'Please Select District',
    // },
    fieldType: 'select',
    options: [], // District options will depend on the selected state
  },
  {
    fieldName: 'constituency',
    fieldTitle: 'నియోజకవర్గం*',
    // validationObj: {
    //   required: 'Please Enter Constituency',
    // },
    fieldType: 'text',
  },
  {
    fieldName: 'mandal',
    fieldTitle: 'మండలం*',
    // validationObj: {
    //   required: 'Please Enter Mandal',
    // },
    fieldType: 'select',
    options: [],
  },
  {
    fieldName: 'village',
    fieldTitle: 'గ్రామం',
    fieldType: 'select',
    options: [], // Or 'select' if you have a predefined list of villages
  },
];

export const referalFieldsTelugu = [
  {
    fieldName: 'referralType',
    fieldTitle: 'రెఫరల్ రకం*',
    // validationObj: {
    //   required: 'Please Select Referral Type',
    // },
    fieldType: 'select',
    options: [], // You'll need to populate this with state options
  },
  {
    fieldName: 'referralMode',
    fieldTitle: 'రెఫరల్ మోడ్*',
    // validationObj: {
    //   required: 'Please Select Referred Mode',
    // },
    fieldType: 'select',
    options: [], // You'll need to populate this with state options
  },
  {
    fieldName: 'referralContact',
    fieldTitle: 'రెఫరల్ ఫోన్ నంబర్',
    fieldType: 'text', // Or 'select' if you have a predefined list of villages
  },

  {
    fieldName: 'referralName',
    fieldTitle: 'రెఫరల్ పేరు',
    fieldType: 'text', // Or 'select' if you have a predefined list of villages
  },

  {
    fieldName: 'referralDesignation',
    fieldTitle: 'రెఫరల్ హోదా',
    fieldType: 'text', // Or 'select' if you have a predefined list of villages
  },
];

export const grievanceRequestFieldsTelugu = [
  {
    fieldName: 'requestMode',
    fieldTitle: 'అభ్యర్థన మోడ్*',
    fieldType: 'select',
    options: [
      { label: 'State', value: 'state' },
      { label: 'Central', value: 'central' },
      { label: 'Private', value: 'private' },
    ],
  },

  {
    fieldName: 'additionalInformation',
    fieldTitle: 'అభ్యర్థన యొక్క అదనపు సమాచారం',
    fieldType: 'textarea',
  },
];

export const dataEntryGrievanceTicketFieldsTelugu = [
  {
    fieldName: 'ticketNo',
    fieldTitle: 'రిఫరెన్స్ నెంబర్*',
    // validationObj: {
    //   required: 'Please Enter Ticket Number',
    // },

    fieldType: 'text',
  },

  {
    fieldName: 'ticketCreatedBy',
    fieldTitle: 'రిఫరెన్స్ రూపొందించిన వారు*',
    fieldType: 'text', // Could be 'disabledInput' if auto-populated
    readOnly: true, // Potentially make it read-only
  },

  {
    fieldName: 'staffDesignation',
    fieldTitle: 'సిబ్బంది హోదా',
    fieldType: 'text', // Could be 'disabledInput' if auto-populated
    readOnly: true,
  },
  {
    fieldName: 'issueOpen',
    fieldTitle: 'రిఫరెన్స్ రూపొందించిన తేదీ',
    fieldType: 'date',
  },
];

export const requestFieldsTelugu = [
  {
    fieldName: 'requestTitle',
    fieldTitle: 'అభ్యర్థన*',
    // validationObj: {
    //   required: 'Please Enter Request Title',
    // },
    fieldType: 'text', // Could be 'disabledInput' if auto-populated
  },
];
